import { useEffect, useState } from 'react'
import { animated, useSpring } from 'react-spring'
import { useAudios } from '../../../assets/useAudios'
import { useSelector } from 'react-redux'

import './AristotleQuote.css'

const AristotleQuote = ({ nextPage }) => {
    const [isVisible, setIsVisible] = useState(true)
    const [quote, setQuote] = useState('')
    const [up, setUp] = useState(false)
    const audio = useAudios()
    const role = useSelector(state => state.role)
    useEffect(() => {
        const TIMEOUT = 12600
        audio.setAndPlay('hissimusa')
        const timeoutOne = setTimeout(() => {
            setIsVisible(false)
        }, TIMEOUT - 500)

        const timeoutTwo = setTimeout(() => {
            nextPage()
        }, TIMEOUT)

        setQuote(selectRandomQuote())

        const interval = setInterval(() => {
            setUp(up => !up)
        }, 1000)

        return () => {
            clearTimeout(timeoutOne)
            clearTimeout(timeoutTwo)
            clearInterval(interval)
        }
        // eslint-disable-next-line
    }, [])

    /*
    const quotes = [
        '“Rhetoric may be defined as the faculty of observing (in any given case) the available means of persuasion”',
        '“All paid jobs absorb and degrade the mind”',
        '“Anger Is A Gift”',
        '“Wise men speak when they have something to say, fools speak because they have to say something”',
        '“You will never do anything in this world without courage”',
        '“Every tragedy consists in tying and untying of a knot”',
        '“Adventure is worthwhile”',
        '“Doubt is the beginning of wisdom”'
    ]
    */

    const selectRandomQuote = () => {
        if (role === 'seller') {
            return '"Kaikki työ pehmentää ja rappeuttaa mieltä"'
        }

        return '"Epäilys on viisauden alku"'
        /*
        const rand = Math.floor(Math.random() * quotes.length)
        return quotes[rand]
        */
    }

    const style = useSpring({ opacity: isVisible ? 1 : 0 })

    const loading = useSpring({
        transform: up ? 'translateY(20px)' : 'translateY(-10px)',
        config: {
            tension: 50,
            mass: 2,
            //friction: 20,
        }
    })

    return (
        <animated.div style={style} className='flex quote-container'>
            <div className='quote-font'>{quote}</div>
            <div className='aristotle'>- Aristoteles 384–322 eaa</div>
            <animated.div style={loading} className='loading-icon'>Ladataan...</animated.div>
        </animated.div>
    )
}

export default AristotleQuote